import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-card',
  templateUrl: './icon-card.component.html',
  styleUrl: './icon-card.component.scss'
})
export class IconCardComponent {
  @Input() iconSrc!: string;
  @Input() iconHeight?: string;
  @Input() iconWidth?: string;
  @Input() title!: string;
  @Input() value?: string;
  @Input() description!: string;
  @Input() variant: 'cream' | 'white' = 'cream';
  @Input() bordered = false;
  @Input() ctaText?: string;
  @Input() ctaLink?: string = '#';
  @Input() blackDescription?: boolean;
  @Input() iconCreamBackgorund?: boolean;


  public get isRouterLink(): boolean {
    return !!this.ctaLink?.startsWith('/');
  }
}
